import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { SPONSA_CSS } from "./sponsaCSS";
import ConfirmModal from "../../../components/Dashcomponents/New/ConfirmModal";
import OnboardingCompleteModal from "../../../components/Dashcomponents/OnboardingCompleteModal.jsx";
import apisecured from "../../../api/apisecured.js";
import {
  setYouTubeConnection,
  setTwitchConnection,
} from "../../../State/authSlicer.js";
import { useUnsavedChanges } from "../../../hooks/useUnsavedChanges.js";
import { setToast } from "../../../State/toastSlice.js";
import API from "../../../api/api.js";

// ─── PREVIEW CSS ─────────────────────────────────────────────────────────────
export const PREVIEW_CSS = `
  .confirm-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(3, 0, 33, 0.85);
    backdrop-filter: blur(8px);
    display: flex; align-items: center; justify-content: center;
    z-index: 2000; opacity: 0; visibility: hidden;
    transition: all 0.2s ease;
  }
  .confirm-modal-overlay.visible { opacity: 1; visibility: visible; }
  .confirm-modal {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 16px; padding: 24px;
    max-width: 400px; width: 90%;
    transform: scale(0.95); transition: transform 0.2s ease;
  }
  .confirm-modal-overlay.visible .confirm-modal { transform: scale(1); }
  .preview-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 16px; padding-bottom: 16px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }
  .preview-modal-platform {
    display: flex; align-items: center; gap: 8px;
    font-size: 14px; font-weight: 600; color: #fff;
  }
  .preview-modal-platform.youtube { color: #FF0000; }
  .preview-modal-platform.twitch { color: #9146FF; }
  .preview-close-btn {
    width: 32px; height: 32px; border-radius: 8px;
    background: rgba(255,255,255,0.04); border: none;
    color: rgba(255,255,255,0.6); cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.2s ease;
  }
  .preview-close-btn:hover { background: rgba(255,255,255,0.03); color: #fff; }
  .preview-modal-body { margin-bottom: 20px; }
  .preview-label-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 10px;
  }
  .preview-label {
    font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.6);
    text-transform: uppercase; letter-spacing: 0.5px;
  }
  .preview-sample-badge {
    font-size: 10px; font-weight: 600; color: #fbbf24;
    background: rgba(251,191,36,0.1); padding: 3px 8px; border-radius: 4px;
  }
  .preview-message-box {
    background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px; padding: 16px; font-size: 14px;
    color: #fff; line-height: 1.6; white-space: pre-wrap;
    word-wrap: break-word; max-height: 200px; overflow-y: auto;
  }
  .preview-message-box a { color: #00FF8F; text-decoration: none; border-bottom: 1px solid transparent; transition: all 0.15s ease; }
  .preview-message-box a:hover { border-bottom-color: #00FF8F; }
  .preview-modal-footer { display: flex; gap: 12px; justify-content: center; }
.variable-chip {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  padding: 4px 8px;
  background: rgba(0, 255, 143, 0.1);
  color: #00FF8F;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
}

.variable-chip:hover {
  background: #00FF8F;
  color: #030021;
}

.variable-chip::before,
.variable-chip::after {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
  z-index: 9999;
}

.variable-chip::after {
  content: attr(data-tooltip);
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: linear-gradient(135deg, rgba(3, 0, 33, 0.97), rgba(10, 5, 40, 0.97));
  border: 1px solid #00FF8F;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4), 0 0 12px rgba(0, 255, 143, 0.1);
  color: #ffffff;
  font-family: 'DM Sans', sans-serif;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 8px;
  white-space: nowrap;
  letter-spacing: 0;
}

.variable-chip::before {
  content: '';
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  border: 5px solid transparent;
  border-top-color: #00FF8F;
}

.variable-chip:hover::before,
.variable-chip:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
    .template-var-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(251, 191, 36, 0.08);
  border: 1px solid rgba(251, 191, 36, 0.25);
  border-radius: 8px;
  margin-top: 8px;
  font-size: 12px;
  color: #fbbf24;
  line-height: 1.5;
}

.template-var-warning svg {
  flex-shrink: 0;
  margin-top: 1px;
  color: #fbbf24;
  stroke: #fbbf24;
}

.template-var-warning code {
  background: rgba(251, 191, 36, 0.15);
  color: #fbbf24;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 11px;
  font-family: monospace;
}
`;

// ─── DEFAULTS ────────────────────────────────────────────────────────────────
const YOUTUBE_DEFAULTS = {
  goalTip:
    '{tipper} just tipped {amount} towards "{goal}"! 🎯 ({progress} funded)',
  goalComplete:
    '🎉 GOAL COMPLETE! "{goal}" has been fully funded! Thank you all! 🎉',
  generalTip: "{tipper} just tipped {amount}! ❤️ Thank you for the support!",
};
const TWITCH_DEFAULTS = {
  goalTip:
    '{tipper} just tipped {amount} towards "{goal}"! 🎯 ({progress} funded)',
  goalComplete:
    '🎉 GOAL COMPLETE! "{goal}" has been fully funded! Thank you all! 🎉',
  generalTip: "{tipper} just tipped {amount}! 💜 Thank you for the support!",
};

const VALID_VARS = {
  goalTip: [
    "tipper",
    "amount",
    "goal",
    "goalurl",
    "progress",
    "remaining",
    "target",
  ],
  goalComplete: ["goal", "goalurl", "target", "progress"],
  generalTip: ["tipper", "amount"],
};

const ALL_KNOWN_VARS = [
  "tipper",
  "amount",
  "goal",
  "goalurl",
  "progress",
  "remaining",
  "target",
  "username",
];

const SAMPLE_DATA = {
  tipper: "CoolGamer123",
  amount: "£10",
  goal: "New Gaming Setup",
  goalurl: "https://sponsa.app/VeloCity/goals/gaming-setup",
  progress: "75%",
  remaining: "£125",
  target: "£500",
  username: "VeloCity",
};

function linkifyUrls(text) {
  const escaped = text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  const urlPattern = /(https?:\/\/[^\s]+)|(sponsa\.app\/[^\s]+)/g;
  return escaped.replace(urlPattern, (match) => {
    const href = match.startsWith("http") ? match : "https://" + match;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
  });
}

function getVarTooltip(v) {
  const tooltips = {
    tipper: "Supporter's display name",
    amount: "Tip amount with currency symbol",
    goal: "Name of the tipped goal",
    goalurl: "Direct link to the goal page",
    progress: "Current funding percentage",
    remaining: "Amount still needed to reach target",
    target: "Goal's target amount",
    username: "Your SPONSA username",
  };
  return tooltips[v] || v;
}

function templatesEqual(a, b) {
  return (
    a.goalTip === b.goalTip &&
    a.goalComplete === b.goalComplete &&
    a.generalTip === b.generalTip
  );
}
function togglesEqual(a, b) {
  return (
    a.goalTip === b.goalTip &&
    a.goalComplete === b.goalComplete &&
    a.generalTip === b.generalTip
  );
}

// ─── SAVE BAR ────────────────────────────────────────────────────────────────
function SaveBar({ visible, onDiscard, onSave, saving }) {
  return (
    <div className={`save-bar${visible ? " visible" : ""}`}>
      <div className="save-bar-inner">
        <span className="save-bar-text">You have unsaved changes</span>
        <button
          className="btn btn-secondary"
          onClick={onDiscard}
          disabled={saving}
        >
          Discard
        </button>
        <button className="btn btn-primary" onClick={onSave} disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
}

// ─── TOGGLE ──────────────────────────────────────────────────────────────────
function Toggle({ checked, onChange, small }) {
  return (
    <label className={`toggle-switch${small ? " small" : ""}`}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="toggle-slider" />
    </label>
  );
}

// ─── PREVIEW MODAL ───────────────────────────────────────────────────────────
function PreviewModal({
  open,
  platform,
  templateText,
  templateKey,
  validVars,
  onClose,
  onSendTest,
}) {
  const platformNames = { youtube: "YouTube", twitch: "Twitch" };
  const platformColors = { youtube: "#FF0000", twitch: "#9146FF" };
  const ytIconPath = `<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/><path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white"/>`;
  const twIconPath = `<path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>`;

  const getPreviewText = () => {
    let text = templateText || "";
    for (const [key, val] of Object.entries(SAMPLE_DATA)) {
      if (validVars.includes(key))
        text = text.replace(new RegExp(`\\{${key}\\}`, "g"), val);
    }
    return linkifyUrls(text);
  };

  if (!open) return null;
  return (
    <div
      className="confirm-modal-overlay visible"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="confirm-modal"
        style={{ maxWidth: 500, textAlign: "left" }}
      >
        <div className="preview-modal-header">
          <div className={`preview-modal-platform ${platform}`}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill={platformColors[platform]}
              dangerouslySetInnerHTML={{
                __html: platform === "youtube" ? ytIconPath : twIconPath,
              }}
            />
            <span>{platformNames[platform]}</span>
          </div>
          <button className="preview-close-btn" onClick={onClose}>
            <svg
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="preview-modal-body">
          <div className="preview-label-row">
            <span className="preview-label">Message Preview</span>
            <span className="preview-sample-badge">Sample Data</span>
          </div>
          <div
            className="preview-message-box"
            dangerouslySetInnerHTML={{ __html: getPreviewText() }}
          />
        </div>
        <div className="preview-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          <button className="btn btn-primary" onClick={onSendTest}>
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
            </svg>
            Send Test
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── TEMPLATE BLOCK ──────────────────────────────────────────────────────────
function TemplateBlock({
  templateKey,
  label,
  value,
  onChange,
  enabled,
  onToggle,
  defaultValue,
  onPreview,
}) {
  const taRef = useRef(null);
  const validVars = VALID_VARS[templateKey] || [];

  const autoResize = (el) => {
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.max(70, el.scrollHeight) + "px";
  };
  useEffect(() => {
    autoResize(taRef.current);
  }, [value]);

  const insertVar = (v) => {
    const el = taRef.current;
    if (!el) return;
    const s = el.selectionStart,
      e = el.selectionEnd;
    const next = value.slice(0, s) + v + value.slice(e);
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      el.setSelectionRange(s + v.length, s + v.length);
    });
  };

  const getInvalidVars = (text) =>
    ALL_KNOWN_VARS.filter(
      (v) => text.includes(`{${v}}`) && !validVars.includes(v),
    );
  const invalidVars = getInvalidVars(value);
  const handleBlur = () => {
    if (value.trim() === "" && defaultValue) onChange(defaultValue);
  };

  return (
    <div className="message-template">
      <div className="template-header">
        <span className="template-label">{label}</span>
        <Toggle small checked={enabled} onChange={onToggle} />
      </div>
      <textarea
        ref={taRef}
        className="template-input"
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          autoResize(e.target);
        }}
        onBlur={handleBlur}
        style={{ overflow: "hidden" }}
      />
      {invalidVars.length > 0 && (
        <div className="template-var-warning">
          <svg
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span>
            {invalidVars.map((v, i) => (
              <span key={v}>
                <code>{`{${v}}`}</code>
                {i < invalidVars.length - 1 ? ", " : ""}
              </span>
            ))}{" "}
            {invalidVars.length === 1 ? "is" : "are"} not available for this
            template and will appear as raw text.
          </span>
        </div>
      )}
      <div className="template-variables">
        {validVars.map((v) => (
          <span
            key={v}
            className="variable-chip"
            data-tooltip={getVarTooltip(v)}
            onClick={() => insertVar(`{${v}}`)}
          >{`{${v}}`}</span>
        ))}
      </div>
      <div className="template-actions">
        <button
          className="template-action-btn"
          onClick={() => onChange(defaultValue)}
        >
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M1 4v6h6" />
            <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
          </svg>
          Reset
        </button>
        <button className="template-action-btn" onClick={onPreview}>
          <svg
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Preview
        </button>
      </div>
    </div>
  );
}

// ─── PLATFORM SECTION ────────────────────────────────────────────────────────
function PlatformSection({
  platform,
  icon,
  color,
  bg,
  title,
  subtitle,
  isConnected,
  connectedEmail,
  onSwitchToggle,
  templates,
  onTemplate,
  toggleStates,
  onToggleState,
  onPreview,
}) {
  const templateKeys = [
    { key: "goalTip", label: "Tips Towards Goals" },
    { key: "goalComplete", label: "Fully Funded Goals" },
    { key: "generalTip", label: "General Tips (No Goal)" },
  ];
  const defaults = platform === "youtube" ? YOUTUBE_DEFAULTS : TWITCH_DEFAULTS;
  const platformColors = { youtube: "#FF0000", twitch: "#9146FF" };
  const ytIconPath = `<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/><path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white"/>`;
  const twIconPath = `<path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>`;

  return (
    <section className="settings-section">
      <div className="section-header">
        <div className="section-icon" style={{ background: bg, color }}>
          {icon}
        </div>
        <div className="section-title-group">
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">{subtitle}</p>
        </div>
        {/* Switch — toggling off triggers disconnect confirmation in parent */}
        <Toggle checked={isConnected} onChange={onSwitchToggle} />
      </div>

      {isConnected && (
        <div className="integration-options">
          <div className="connected-account-banner">
            <div className="connected-account-info">
              <svg
                viewBox="0 0 24 24"
                fill={platformColors[platform]}
                width="20"
                height="20"
                dangerouslySetInnerHTML={{
                  __html: platform === "youtube" ? ytIconPath : twIconPath,
                }}
              />
              <span>
                Connected as <strong>{connectedEmail}</strong>
              </span>
            </div>
            <span
              className="status-badge connected"
              style={{ fontSize: "11px", padding: "4px 8px" }}
            >
              <svg
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                style={{ width: "12px", height: "12px" }}
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Active
            </span>
          </div>

          {templateKeys.map(({ key, label }) => (
            <TemplateBlock
              key={key}
              templateKey={key}
              label={label}
              value={templates[key]}
              onChange={(v) => onTemplate(key, v)}
              defaultValue={defaults[key]}
              enabled={toggleStates[key]}
              onToggle={(e) => onToggleState(key, e.target.checked)}
              onPreview={() => onPreview(platform, key, templates[key])}
            />
          ))}
        </div>
      )}
    </section>
  );
}

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
export default function ChatbotSettingPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userlogin = useSelector((state) => state.auth);
  const { youtubeEmail, isYouTubeConnected, twitchEmail, isTwitchConnected } =
    userlogin;

  const [searchParams] = useSearchParams();

  // Connection state
  const [localYouTubeConnected, setLocalYouTubeConnected] =
    useState(!!isYouTubeConnected);
  const [localYouTubeEmail, setLocalYouTubeEmail] = useState(
    youtubeEmail || "",
  );
  const [localTwitchConnected, setLocalTwitchConnected] =
    useState(!!isTwitchConnected);
  const [localTwitchEmail, setLocalTwitchEmail] = useState(twitchEmail || "");

  // Templates per platform
  const [ytTemplates, setYtTemplates] = useState({ ...YOUTUBE_DEFAULTS });
  const [twTemplates, setTwTemplates] = useState({ ...TWITCH_DEFAULTS });

  // Toggle states per platform
  const [ytToggleStates, setYtToggleStates] = useState({
    goalTip: true,
    goalComplete: true,
    generalTip: true,
  });
  const [twToggleStates, setTwToggleStates] = useState({
    goalTip: true,
    goalComplete: true,
    generalTip: true,
  });

  // Saved snapshots for dirty comparison
  const [savedYt, setSavedYt] = useState({
    templates: { ...YOUTUBE_DEFAULTS },
    toggles: { goalTip: true, goalComplete: true, generalTip: true },
  });
  const [savedTw, setSavedTw] = useState({
    templates: { ...TWITCH_DEFAULTS },
    toggles: { goalTip: true, goalComplete: true, generalTip: true },
  });

  const [saving, setSaving] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Disconnect confirmation modals
  const [showDisconnectYouTube, setShowDisconnectYouTube] = useState(false);
  const [showDisconnectTwitch, setShowDisconnectTwitch] = useState(false);

  const [previewState, setPreviewState] = useState({
    open: false,
    platform: "youtube",
    templateKey: "goalTip",
    templateText: "",
  });

  // Computed dirty — auto-clears when changes are undone
  const dirty =
    (localYouTubeConnected &&
      (!templatesEqual(ytTemplates, savedYt.templates) ||
        !togglesEqual(ytToggleStates, savedYt.toggles))) ||
    (localTwitchConnected &&
      (!templatesEqual(twTemplates, savedTw.templates) ||
        !togglesEqual(twToggleStates, savedTw.toggles)));

  useUnsavedChanges(dirty);

  // ── Fetch YouTube status ──
  useEffect(() => {
    const fetch = async () => {
      if (!userlogin.uid) return;
      try {
        const res = await apisecured.get("account/youtube/status");
        const data = res.data;
        setLocalYouTubeConnected(data.connected);
        setLocalYouTubeEmail(data.email || "");
        dispatch(
          setYouTubeConnection({
            connected: data.connected,
            email: data.email || "",
          }),
        );
      } catch (err) {
        console.error("Error fetching YouTube status", err);
      }
    };
    if (!isYouTubeConnected || !youtubeEmail) fetch();
    else {
      setLocalYouTubeConnected(isYouTubeConnected);
      setLocalYouTubeEmail(youtubeEmail);
    }
  }, [userlogin.uid]);

  // ── Fetch Twitch status ──
  useEffect(() => {
    const fetch = async () => {
      if (!userlogin.uid) return;
      try {
        const res = await apisecured.get("account/twitch/status");
        const data = res.data;
        setLocalTwitchConnected(data.connected);
        setLocalTwitchEmail(data.email || "");
        dispatch(
          setTwitchConnection({
            connected: data.connected,
            email: data.email || "",
          }),
        );
      } catch (err) {
        console.error("Error fetching Twitch status", err);
      }
    };
    if (!isTwitchConnected || !twitchEmail) fetch();
    else {
      setLocalTwitchConnected(isTwitchConnected);
      setLocalTwitchEmail(twitchEmail);
    }
  }, [userlogin.uid]);

  // ── Fetch chatbot settings for both platforms ──
  useEffect(() => {
    if (!userlogin.uid) return;
    const fetchSettings = async (platform) => {
      try {
        const res = await apisecured.get("/account/get/chatbotsettings", {
          params: { platform },
        });
        const data = res.data;
        const defaults =
          platform === "youtube" ? YOUTUBE_DEFAULTS : TWITCH_DEFAULTS;
        const templates = {
          goalTip: data.tipMessageTemplate || defaults.goalTip,
          goalComplete:
            data.fullyFundedMessageTemplate || defaults.goalComplete,
          generalTip: data.generalTipMessageTemplate || defaults.generalTip,
        };
        const toggles = {
          goalTip: data.receiveAllTips ?? true,
          goalComplete: data.receiveGoalFunded ?? true,
          generalTip: data.receiveGeneralTips ?? false,
        };
        if (platform === "youtube") {
          setYtTemplates(templates);
          setYtToggleStates(toggles);
          setSavedYt({ templates, toggles });
        } else {
          setTwTemplates(templates);
          setTwToggleStates(toggles);
          setSavedTw({ templates, toggles });
        }
      } catch (err) {
        console.error(`Failed to fetch ${platform} chatbot settings`, err);
      }
    };
    fetchSettings("youtube");
    fetchSettings("twitch");
  }, [userlogin.uid]);

  // ── Success modal from URL ──
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("success") === "true") {
      setShowSuccessModal(true);
      params.delete("success");
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
  }, []);

  // ── YouTube switch — connect or show disconnect modal ──
  const handleYouTubeSwitchToggle = () => {
    if (localYouTubeConnected) {
      setShowDisconnectYouTube(true); // show confirmation first
    } else {
      window.location.href = `${API}account/youtube/connect`;
    }
  };

  // ── Confirmed YouTube disconnect ──
  const handleYouTubeDisconnectConfirm = async () => {
    try {
      const res = await apisecured.post("/account/youtube/disconnect");
      if (res.data.success) {
        dispatch(
          setToast({
            message: "YouTube disconnected successfully!",
            type: "success",
          }),
        );
        setLocalYouTubeConnected(false);
        setLocalYouTubeEmail("");
        dispatch(setYouTubeConnection({ connected: false, email: "" }));
      }
    } catch (err) {
      dispatch(
        setToast({ message: "Failed to disconnect YouTube", type: "error" }),
      );
    } finally {
      setShowDisconnectYouTube(false);
    }
  };

  // ── Twitch switch — connect or show disconnect modal ──
  const handleTwitchSwitchToggle = () => {
    if (localTwitchConnected) {
      setShowDisconnectTwitch(true); // show confirmation first
    } else {
      window.location.href = `${API}account/twitch/connect`;
    }
  };

  // ── Confirmed Twitch disconnect ──
  const handleTwitchDisconnectConfirm = async () => {
    try {
      const res = await apisecured.post("/account/twitch/disconnect");
      if (res.data.success) {
        dispatch(
          setToast({
            message: "Twitch disconnected successfully!",
            type: "success",
          }),
        );
        setLocalTwitchConnected(false);
        setLocalTwitchEmail("");
        dispatch(setTwitchConnection({ connected: false, email: "" }));
      }
    } catch (err) {
      dispatch(
        setToast({ message: "Failed to disconnect Twitch", type: "error" }),
      );
    } finally {
      setShowDisconnectTwitch(false);
    }
  };

  // ── Template / toggle updaters ──
  const updateYt = (key, val) => setYtTemplates((p) => ({ ...p, [key]: val }));
  const updateTw = (key, val) => setTwTemplates((p) => ({ ...p, [key]: val }));
  const updateYtToggle = (key, val) =>
    setYtToggleStates((p) => ({ ...p, [key]: val }));
  const updateTwToggle = (key, val) =>
    setTwToggleStates((p) => ({ ...p, [key]: val }));

  // ── Save ──
  const handleSave = async () => {
    setSaving(true);
    try {
      const requests = [];
      if (localYouTubeConnected) {
        requests.push(
          apisecured.post("/account/settings/chatbot", {
            platform: "youtube",
            receiveAllTips: ytToggleStates.goalTip,
            receiveGoalFunded: ytToggleStates.goalComplete,
            receiveGeneralTips: ytToggleStates.generalTip,
            tipMessageTemplate: ytTemplates.goalTip,
            fullyFundedMessageTemplate: ytTemplates.goalComplete,
            generalTipMessageTemplate: ytTemplates.generalTip,
          }),
        );
      }
      if (localTwitchConnected) {
        requests.push(
          apisecured.post("/account/settings/chatbot", {
            platform: "twitch",
            receiveAllTips: twToggleStates.goalTip,
            receiveGoalFunded: twToggleStates.goalComplete,
            receiveGeneralTips: twToggleStates.generalTip,
            tipMessageTemplate: twTemplates.goalTip,
            fullyFundedMessageTemplate: twTemplates.goalComplete,
            generalTipMessageTemplate: twTemplates.generalTip,
          }),
        );
      }

      const results = await Promise.all(requests);
      let rIdx = 0;
      if (localYouTubeConnected) {
        const d = results[rIdx++].data;
        setSavedYt({
          templates: {
            goalTip: d.tipMessageTemplate || ytTemplates.goalTip,
            goalComplete:
              d.fullyFundedMessageTemplate || ytTemplates.goalComplete,
            generalTip: d.generalTipMessageTemplate || ytTemplates.generalTip,
          },
          toggles: {
            goalTip: d.receiveAllTips ?? ytToggleStates.goalTip,
            goalComplete: d.receiveGoalFunded ?? ytToggleStates.goalComplete,
            generalTip: d.receiveGeneralTips ?? ytToggleStates.generalTip,
          },
        });
      }
      if (localTwitchConnected) {
        const d = results[rIdx++].data;
        setSavedTw({
          templates: {
            goalTip: d.tipMessageTemplate || twTemplates.goalTip,
            goalComplete:
              d.fullyFundedMessageTemplate || twTemplates.goalComplete,
            generalTip: d.generalTipMessageTemplate || twTemplates.generalTip,
          },
          toggles: {
            goalTip: d.receiveAllTips ?? twToggleStates.goalTip,
            goalComplete: d.receiveGoalFunded ?? twToggleStates.goalComplete,
            generalTip: d.receiveGeneralTips ?? twToggleStates.generalTip,
          },
        });
      }

      dispatch(
        setToast({
          message: "Chatbot settings saved successfully!",
          type: "success",
        }),
      );
    } catch (error) {
      dispatch(
        setToast({
          message: `Failed to save settings: ${error?.response?.data?.error || "An unknown error occurred."}`,
          type: "error",
        }),
      );
    } finally {
      setSaving(false);
    }
  };

  // ── Discard — instant, no confirmation ──
  const handleDiscard = () => {
    setYtTemplates({ ...savedYt.templates });
    setYtToggleStates({ ...savedYt.toggles });
    setTwTemplates({ ...savedTw.templates });
    setTwToggleStates({ ...savedTw.toggles });
  };

  // ── Preview ──
  const handlePreview = (platform, templateKey, templateText) =>
    setPreviewState({ open: true, platform, templateKey, templateText });
  const handlePreviewClose = () =>
    setPreviewState((s) => ({ ...s, open: false }));
  const handleSendTest = async () => {
    const endpoint =
      previewState.platform === "youtube"
        ? "/account/test/youtube/chatbot"
        : "/account/test/twitch/chatbot";

    try {
      await apisecured.post(endpoint, { message: previewState.templateText });
      handlePreviewClose();
      dispatch(
        setToast({
          message: `Test message sent to ${previewState.platform === "youtube" ? "YouTube Live Chat" : "Twitch Chat"}!`,
          type: "success",
        }),
      );
    } catch (err) {
      handlePreviewClose();
      dispatch(
        setToast({
          message: "There was an error sending a test message.",
          type: "error",
        }),
      );
    }
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    const params = new URLSearchParams(location.search);
    params.delete("success");
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  const ytIcon = (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z" />
      <path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="white" />
    </svg>
  );
  const twIcon = (
    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z" />
    </svg>
  );

  return (
    <>
      <style>{SPONSA_CSS}</style>
      <style>{PREVIEW_CSS}</style>
      <div className="sp-settings-wrap">
        <div className="sp-settings-inner">
          <header className="page-header" style={{ marginBottom: 32 }}>
            <h1 className="page-title">Chatbot Settings</h1>
            <p className="page-description">
              Automatically post messages to your YouTube and Twitch chat.
            </p>
          </header>

          <section className="settings-section">
            <div className="section-header">
              <div className="section-icon cyan">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div className="section-title-group">
                <h2 className="section-title">How It Works</h2>
                <p className="section-subtitle">
                  Automated chat messages for your streams
                </p>
              </div>
            </div>
            <div className="info-box">
              <p>
                <strong>SPONSABot</strong> will automatically post messages to
                your chat when tips come in or goals are funded.
              </p>
              <p>
                ⚠️ <strong>Important:</strong> You must add{" "}
                <code>SPONSABot</code> as a moderator in your chat for it to
                work.
              </p>
              <p>
                📖 Setup guides:{" "}
                <a
                  href="https://help.sponsa.app/for-creators/4yqnnFziGPBYDwLaFWA41L/sponsabot-for-youtube/6K6LWoLgssz1oEW66GqzpN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube Guide
                </a>
                {" · "}
                <a
                  href="https://help.sponsa.app/for-creators/4yqnnFziGPBYDwLaFWA41L/sponsabot-for-twitch/6K6LWoLgsscF4a5oihkN6j"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitch Guide
                </a>
              </p>
            </div>
          </section>

          <PlatformSection
            platform="youtube"
            icon={ytIcon}
            color="#FF0000"
            bg="rgba(255,0,0,0.1)"
            title="YouTube Chatbot"
            subtitle="Toggle to connect or disconnect YouTube"
            isConnected={localYouTubeConnected}
            connectedEmail={localYouTubeEmail}
            onSwitchToggle={handleYouTubeSwitchToggle}
            templates={ytTemplates}
            onTemplate={updateYt}
            toggleStates={ytToggleStates}
            onToggleState={updateYtToggle}
            onPreview={handlePreview}
          />

          <PlatformSection
            platform="twitch"
            icon={twIcon}
            color="#9146FF"
            bg="rgba(145,70,255,0.1)"
            title="Twitch Chatbot"
            subtitle="Toggle to connect or disconnect Twitch"
            isConnected={localTwitchConnected}
            connectedEmail={localTwitchEmail}
            onSwitchToggle={handleTwitchSwitchToggle}
            templates={twTemplates}
            onTemplate={updateTw}
            toggleStates={twToggleStates}
            onToggleState={updateTwToggle}
            onPreview={handlePreview}
          />

          <div style={{ height: 80 }} />
        </div>
      </div>

      <SaveBar
        visible={dirty}
        onDiscard={handleDiscard}
        onSave={handleSave}
        saving={saving}
      />

      {/* Disconnect confirmation modals */}
      <ConfirmModal
        open={showDisconnectYouTube}
        onClose={() => setShowDisconnectYouTube(false)}
        onConfirm={handleYouTubeDisconnectConfirm}
        title="Disconnect YouTube?"
        description="SPONSABot will stop posting to your YouTube live chat. You can reconnect anytime."
        confirmText="Disconnect"
        cancelText="Cancel"
        isDanger={true}
      />

      <ConfirmModal
        open={showDisconnectTwitch}
        onClose={() => setShowDisconnectTwitch(false)}
        onConfirm={handleTwitchDisconnectConfirm}
        title="Disconnect Twitch?"
        description="SPONSABot will stop posting to your Twitch chat. You can reconnect anytime."
        confirmText="Disconnect"
        cancelText="Cancel"
        isDanger={true}
      />

      <PreviewModal
        open={previewState.open}
        platform={previewState.platform}
        templateText={previewState.templateText}
        validVars={VALID_VARS[previewState.templateKey] || []}
        onClose={handlePreviewClose}
        onSendTest={handleSendTest}
      />

      <OnboardingCompleteModal
        open={showSuccessModal}
        onClose={handleCloseSuccessModal}
        onModalClose={handleCloseSuccessModal}
      />
    </>
  );
}
